/**
 * External dependencies.
 */
import { isEmpty, has, assign } from 'lodash';

/**
 * Internal dependencies.
 */
// import { getBackgroundStyle, getTextStyle, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( coreStyles, gutenifyStyles, isAdmin = false ) {
	const textColor = has( coreStyles, 'color.text' ) ? ( coreStyles.color.text ) : '';
	const backgroundColor = has( coreStyles, 'color.background' ) ? ( coreStyles.color.background ) : '';
	const h1Color = has( coreStyles, 'elements.h1.color.text' ) ? ( coreStyles.elements.h1.color.text ) : '';
	const buttonBackgroundColor = has( coreStyles, 'blocks.core/button.color.background' ) ? ( coreStyles.blocks[ 'core/button' ].color.background ) : '';
	const buttonTextColor = has( coreStyles, 'blocks.core/button.color.text' ) ? ( coreStyles.blocks[ 'core/button' ].color.text ) : '';

	const linkColor = has( coreStyles, 'elements.link.color.text' ) ? ( coreStyles.elements.link.color.text ) : '';
	const linkHoverColor = has( gutenifyStyles, 'elements.linkHover.color.text' ) ? ( gutenifyStyles.elements.linkHover.color.text ) : '';

	const buttonHoverTextColor = has( gutenifyStyles, 'blocks.core/button.hover.color.text' ) ? ( gutenifyStyles.blocks[ 'core/button' ].hover.color.text ) : '';
	const buttonHoverBackgroundColor = has( gutenifyStyles, 'blocks.core/button.hover.color.background' ) ? ( gutenifyStyles.blocks[ 'core/button' ].hover.color.background ) : '';

	let css = '';

	css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button .wp-block-button__link{
		${ buttonTextColor ? `color: ${ buttonTextColor };` : '' }
		${ buttonBackgroundColor ? `background-color: ${ buttonBackgroundColor };` : '' }
	}`;
	if ( buttonBackgroundColor ) {
		css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } .is-style-outline > .wp-block-button__link:not(.has-background){
			${ buttonBackgroundColor ? `background-color: transparent;` : '' }
		}`;
	}

	css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button.is-style-outline > .wp-block-button__link:not(.has-text-color){
		${ buttonBackgroundColor ? `color: ${ buttonBackgroundColor };` : '' }
	}`;
	// .is-style-outline > .wp-block-button__link:not(.has-text-color)

	css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button .wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover,
	${ isAdmin ? '.editor-styles-wrapper  .gutenify-button-link.wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover,' : '' }
	${ isAdmin ? '.editor-styles-wrapper ' : '' } .wp-block-button.is-style-outline .wp-block-button__link.wp-block-button__link:not(.has-background):not(.has-text-color):hover{
		${ buttonHoverTextColor ? `color: ${ buttonHoverTextColor };` : '' }
		${ buttonHoverBackgroundColor ? `background-color: ${ buttonHoverBackgroundColor };` : '' }
	}`;

	css += `${ isAdmin ? '.editor-styles-wrapper ' : '' } a:hover,a:active{
		${ linkHoverColor ? `color: ${ linkHoverColor };` : '' }
	}`;

	return css;
}

export default styling;

